import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useState } from 'react'

export default function VisaoMissao() {
  // Define os blocos fixos de Visão e Missão
  const [activeIndex, setActiveIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)
  const isMobile = window.innerWidth < 768

  // Blocos com apenas títulos
  const blocks = [
    {
      title: 'Missão',
      backgroundImage: isMobile
        ? '/assets/slide-missao-mobile.png'
        : '/assets/slide-missao.png',
    },
    {
      title: 'Visão',
      backgroundImage: isMobile
        ? '/assets/slide-visao-mobile.png'
        : '/assets/slide-visao.png',
    },
  ]

  // Função para alternar entre os blocos
  const handleBlockClick = () => {
    if (!isAnimating) {
      setIsAnimating(true)
      setActiveIndex(prevIndex => (prevIndex === 0 ? 1 : 0))
      // Desativa o estado de animação após a transição
      setTimeout(() => setIsAnimating(false), 700)
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isAnimating) {
        setIsAnimating(true)
        setActiveIndex(prevIndex => (prevIndex === 0 ? 1 : 0))
        // Desativa o estado de animação após a transição
        setTimeout(() => setIsAnimating(false), 700)
      }
    }, 5000)

    // Limpa o intervalo quando o componente é desmontado
    return () => clearInterval(interval)
  }, [isAnimating])

  return (
    <section className="py-20 relative bg-[#040116] overflow-hidden">
      <div className="lg:shadow-xl">
        {/* Bloco superior */}
        <motion.div
          className="mx-6 lg:mx-16 rounded-t-3xl py-5 px-12 backdrop-blur-md cursor-pointer bg-[#FFFFFF33] transition-all duration-500"
          onClick={handleBlockClick}
          whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}
          whileTap={{ scale: 0.98 }}
        >
          <motion.p
            className="text-[#FFFFFF]/31 text-4xl"
            key={blocks[activeIndex === 0 ? 1 : 0].title}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {blocks[activeIndex === 0 ? 1 : 0].title}
          </motion.p>
        </motion.div>

        {/* Bloco principal com imagem de fundo */}
        <AnimatePresence mode="wait">
          <motion.div
            key={activeIndex}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7, ease: 'easeInOut' }}
            className="h-fit"
          >
            <img
              src={`${blocks[activeIndex].backgroundImage}`}
              alt=""
              className="object-cover h-full w-full relative z-10"
            />
          </motion.div>
        </AnimatePresence>

        {/* Bloco inferior */}
        <motion.div
          className="rounded-b-3xl backdrop-blur-md mx-6 lg:mx-16 bg-[#FFFFFF33] transition-all duration-500 h-[70px]"
          whileHover={{ backgroundColor: 'rgba(255, 255, 255, 0.25)' }}
        />
      </div>
    </section>
  )
}